import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PtrabSessionRepository } from '@app/domain/repositories/ptrab/session/session.repository.contract';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class PtrabSessionRepositoryImpl extends MRepository implements PtrabSessionRepository {
  private readonly url = '/ptrab/login';

  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  getSessionStatus(): Observable<HttpErrorResponse | void> {
    return this.get<void>(`${this.url}/status`).pipe(catchError((error = new HttpErrorResponse({})) => of(error)));
  }

  ptrabLogin(password: string, sms_hash?: string): Observable<MSafeAny> {
    const body = sms_hash ? { password, sms_hash } : { password };
    return this.post(this.url, { body });
  }

  ptrabLogout(): Observable<MSafeAny> {
    return this.post(`${this.url}/logout`, {});
  }
}
